export const NAVBAR_ITEMS = [
  {
    title: "ورود/ثبت نام",
    href: "/login/",
  },
  {
    title: "خانه",
    href: "/",
  },
  {
    title: "درباره ما",
    href: "/about-us",
  },
];
export const EXTERNAL_LINKS = [{ title: "test", href: "/" }];
